import React from 'react';
import PropTypes from 'prop-types';

import { Textarea } from 'components/ui';

import * as Styled from './Description.styles';

export const Description = ({ form }) => {
  const { values, setFieldValue, errors } = form;

  return (
    <Styled.Wrapper>
      <Textarea 
        onChange={(value) => setFieldValue('comments', value)} 
        label="Opis kosztu" 
        value={values.comments}
        error={errors.comments} />
    </Styled.Wrapper>
  );
};

Description.propTypes = {
  form: PropTypes.object.isRequired,
  isAdvancedView: PropTypes.bool,
};
